import { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../index';

interface DebounceJob {
  id: string;
  status: string;
  createdAt: string;
  completedAt?: string;
  totalEmails: number;
  processedEmails: number;
}

export const useDebounce = () => {
  const [data, setData] = useState<DebounceJob[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchJobs = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await apiClient.get<DebounceJob[]>('/api/debounce-jobs');
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch debounce jobs');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchJobs();
  }, [fetchJobs]);

  return {
    data,
    loading,
    error,
    refetch: fetchJobs,
  };
};